export interface EngagementPlan {
  id: string;
  title: string;
  description: string;
  points: readonly string[];
}

export const ENGAGEMENT_PLANS: readonly EngagementPlan[] = [
  {
    id: 'retainer',
    title: '月額顧問',
    description:
      '外部 CTO の視点で、技術判断の相談役になります。定例で構成とコストを点検し、チームの「これで合っているか」に答え続けます。',
    points: [
      '定例での設計・運用レビュー',
      '構成とコストの定期点検',
      '開発チームの技術相談窓口',
      'Claude Code・Kiro 活用の継続支援',
    ],
  },
  {
    id: 'spot',
    title: 'スポット',
    description:
      '期間と範囲を区切って、設計・構築・移行を実施します。終わったあとに自分たちで回せるよう、構成と手順を残して引き渡します。',
    points: [
      'AWS 環境の設計・構築',
      '既存環境の AWS 移行',
      'Well-Architected に沿った設計レビュー',
      'CI/CD の構築・改善',
    ],
  },
];

export const RESALE_PLAN: EngagementPlan = {
  id: 'resale',
  title: 'AWS の契約を、eNEW 経由に',
  description:
    '再販・請求代行として、AWS との契約と請求の窓口になります。請求は円建て、すでにお使いのアカウントもそのまま移管できます。顧問やスポットと組み合わせると、請求の数字と設計の判断を同じ窓口で扱えます。',
  points: [
    '円建ての請求書',
    '既存アカウントの移管に対応',
    '請求と技術相談が、同じ窓口',
    '顧問・スポットとの組み合わせ可',
  ],
};

export const GETTING_STARTED =
  'お問い合わせフォームから、現状をひとことお知らせください。オンラインでお話ししてから、顧問かスポットか、まだ決めなくてよいかを一緒に判断します。';
